import iconLinkedin from '@/assets/img/author/linkedin.svg';
import iconInstagram from '@/assets/img/author/instagram.svg';
import iconWebsite from '@/assets/img/author/globe.svg';

const AUTHOR_LINK_ICONS = {
  linkedin: iconLinkedin,
  instagram: iconInstagram,
  website: iconWebsite
};

const AUTHOR_LINK_TITLES = {
  linkedin: 'LinkedIn',
  instagram: 'Instagram'
};

export const authorLinkIcon = (type) => AUTHOR_LINK_ICONS[type] || iconWebsite;

export const authorLinkTitle = (link) =>
  link.title && !link.title.startsWith('admin_labels.') ? link.title : AUTHOR_LINK_TITLES[link.type] || link.url;

export const toIsoDate = (date) => {
  let match = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(date || '');
  return match ? `${match[3]}-${match[2]}-${match[1]}` : date;
};
